import React, { useState } from 'react';
import { getCurrentSku } from '@catalogo/core-sku';
import { Data } from '@catalogo/core-sku/src/types';
import { fmtServices } from '@catalogo/service-americanas-warranty/src/helpers';
import {
  fmtMainService,
  getInfoForWarranty,
  getMaxInstallment,
  toggleServiceSelect,
  getMainService,
} from '../helpers/services-pdp';
import { IServicesPDPProps, IServicesPDP, IWithServicesPDP } from '../types/warranty-pdp';

export const withServicesPDP = (Component: React.FC<IWithServicesPDP>) => (props: IServicesPDPProps) => {
  const { product, history, dispatchMetrics, parsedQs } = props;
  const [isServiceSelected, setIsServiceSelected] = useState(false);
  const [dispatchedEvent, setDispatchedEvent] = useState(false);

  const data = { product };
  const productId = data?.product?.id;
  const currentSku = getCurrentSku((data as unknown) as Data, parsedQs);
  const formattedServices = fmtServices({ currentSku, maxInstallment: getMaxInstallment(currentSku), productId });
  const services = formattedServices?.[0]?.services;
  const mainService = getMainService(services);
  const formattedMainService = fmtMainService(mainService);

  const servicesPDP: IServicesPDP = {
    infoForComponent: {
      isServiceSelected,
      history,
      toggleServiceSelect: toggleServiceSelect(
        isServiceSelected,
        setIsServiceSelected,
        dispatchMetrics,
        dispatchedEvent,
        setDispatchedEvent
      ),
      ...formattedMainService,
    },
    infoForWarranty: getInfoForWarranty(mainService, isServiceSelected),
  };

  return <Component servicesPDP={servicesPDP} {...props} />;
};

export default withServicesPDP;
